import React, { useState, useEffect } from "react";
import "./App.css";
import Navbar from "./component/Navbar/Navbar.js";
import Home from "./Home";
import Login from "./Login";
import { Route, Switch } from "react-router-dom";
import Solution from "./Solution";
import Pricing from "./Pricing";
import Blog from "./Blog";
import signUp from "./Signup";
import "./component/Slider/Slider.css";
import "@splidejs/splide/dist/css/themes/splide-skyblue.min.css";
import Dropdown from "./component/Navbar/Dropdown";
import { unstable_renderSubtreeIntoContainer } from "react-dom";
import WhitePartner from "./Partner1";
import channelPartner from "./Partner2";
import paneloSign from "./Solutions/Sign";
import paneloVision from "./Solutions/Vision";
import Article from "./Article";
import Application from "./Applications/index";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const hideMenu = () => {
      if (window.innerWidth > 768 && isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", hideMenu);

    return () => {
      window.removeEventListener("resize", hideMenu);
    };
  });

  return (
    <div className="App">
      <Navbar toggle={toggle} />
      <Dropdown isOpen={isOpen} toggle={toggle} />

      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/solution" component={Solution} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/signup" component={signUp} />
        <Route exact path="/white-label-partner" component={WhitePartner} />
        <Route exact path="/channel-partner" component={channelPartner} />
        <Route exact path="/panelo-sign" component={paneloSign} />
        <Route exact path="/panelo-vision" component={paneloVision} />
        <Route exact path="/article/:slug" component={Article} />
        <Route exact path="/application/:slug" component={Application} />
      </Switch>
    </div>
  );
}
export default App;
